<template>
  <div>
    <a-form-model ref="ruleForm" :layout="layout" :model="form" :rules="rules">
      <!-- <a-form-model-item label="Resources" prop="resource">
        <a-radio-group v-model="form.resource">
          <a-radio value="1"> Sponsor </a-radio>
          <a-radio value="2"> Venue </a-radio>
        </a-radio-group>
      </a-form-model-item> -->
      <a-form-model-item label="试题内容：" prop="topic">
        <a-textarea v-model="form.topic" placeholder="请输入试题内容" :auto-size="{ minRows: 3, maxRows: 8 }" />
      </a-form-model-item>
      <a-form-model-item label="关联项：" prop="relevance">
        <a-select mode="multiple" v-model="form.relevance" placeholder="请选择关联项" :options="relevanceOptions" />
      </a-form-model-item>
      <a-form-model-item label="判断类型：" prop="judgmentType">
        <a-select
          v-model="form.judgmentType"
          placeholder="请选择判断类型"
          :options="judgmentTypeOptions"
          @change="changeJudgmentType"
        />
      </a-form-model-item>
      <a-form-model-item label="计分方式：" prop="judgmentType">
        <a-select
          v-model="form.scoringFormula"
          placeholder="请选择计分方式"
          :options="scoringFormulaOptions"
          @change="changeScoringFormula"
        />
      </a-form-model-item>
      <a-form-model-item
        class="add-input"
        v-for="(item, index) in form.topicOptions"
        :key="item.key"
        :label="index === 0 ? '题目选项：' : ''"
        :prop="'topicOptions.' + index + '.value'"
        :rules="{
          required: true,
          message: `题目选项${item.key}不能为空`,
          trigger: 'blur',
        }"
      >
        <a-input v-model="item.value" disabled :addon-before="item.key" placeholder="请输入">
          <div slot="addonAfter" style="width: 100px">
            <span>分值：</span>
            <a-input-number v-model="item.score" disabled style="width: 71px" @change="changeeScore(item, index)" />
          </div>
          <!-- <a-select slot="addonAfter" default-value=".com" style="width: 80px">
            <a-select-option value=".com"> .com </a-select-option>
            <a-select-option value=".jp"> .jp </a-select-option>
            <a-select-option value=".cn"> .cn </a-select-option>
            <a-select-option value=".org"> .org </a-select-option>
          </a-select> -->
        </a-input>
      </a-form-model-item>
      <a-form-model-item>
        <a-button type="primary" @click="onSubmit">保存</a-button>
        <a-button style="margin-left: 10px" @click="resetForm">重置</a-button>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
const topicOptions = [
  {
    key: 'A',
    value: '是',
    score: 1,
  },
  {
    key: 'B',
    value: '否',
    score: 0,
  },
];
export default {
  name: 'Judgment',
  props: {
    editFormRecord: {
      type: Object,
      default: () => ({}),
    },
    // 插入题目序号，大于0才是插入题目
    insertNum: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      layout: 'vertical',
      form: {
        topic: '',
        relevance: [],
        judgmentType: '0',
        scoringFormula: '0',
        topicOptions,
      },
      relevanceOptions: [
        { label: '学习好', value: '学习好' },
        { label: '情绪稳定', value: '情绪稳定' },
        { label: '家庭条件', value: '家庭条件' },
        { label: '工作压力', value: '工作压力' },
        { label: '身体健康', value: '身体健康' },
        { label: '兴趣爱好', value: '兴趣爱好' },
        { label: '其他', value: '其他' },
      ],
      judgmentTypeOptions: [
        { label: '是-否', value: '0' },
        { label: '对-错', value: '1' },
        { label: '正确-错误', value: '2' },
      ],
      scoringFormulaOptions: [
        { label: '正向计分', value: '0' },
        { label: '反向计分', value: '1' },
      ],
      rules: {
        topic: [{ required: true, message: '请输入试题内容', trigger: 'blur' }],
        relevance: [{ required: true, message: '请选择关联项', trigger: 'blur' }],
        judgmentType: [{ required: true, message: '请选择判断类型', trigger: 'blur' }],
      },
      quesTableList: [],
    };
  },
  watch: {
    editFormRecord: {
      handler(newVal) {
        if (Object.keys(newVal).length > 0) {
          this.form = {
            ...newVal,
            topicOptions: newVal.topicOptions || topicOptions,
            judgmentType: newVal.judgmentType || '0',
          };
        } else {
          this.form = {
            ...this.form,
            topicOptions: topicOptions,
          };
        }
        console.log('监听到编辑数据：', this.form);
        this.form.judgmentType && this.changeJudgmentType(this.form.judgmentType);
      },
      immediate: true,
    },
  },
  methods: {
    changeJudgmentType(value) {
      // console.log('选择项：', value);
      const currTypeOptions = [
        ['是', '否'],
        ['对', '错'],
        ['正确', '错误'],
      ][value].map((item, index) => ({
        key: String.fromCharCode(65 + index),
        value: item,
        score: index == 0 ? 1 : 0,
      }));
      this.$set(this.form, 'topicOptions', currTypeOptions);
    },
    changeScoringFormula() {
      this.$set(
        this.form,
        'topicOptions',
        this.form.topicOptions.map((item) => ({ ...item, score: item.score == 0 ? 1 : 0 }))
      );
    },
    changeeScore(item, index) {
      console.log('修改分值：', item, index);
    },
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          // this.quesTableList.push(this.form);
          const quesTableList = JSON.parse(localStorage.getItem('quesTableList')) || [];
          const index = quesTableList.findIndex((item) => item.id && item.id == this.editFormRecord.id);
          console.log('提交信息：', this.form, '更新的索引', index);
          if (index !== -1) {
            quesTableList.splice(index, 1, { ...quesTableList[index], ...this.form });
            console.log('更新后的列表信息：', quesTableList);
            localStorage.setItem('quesTableList', JSON.stringify(quesTableList));
            // this.$emit('refreshData', 'edit');
          } else {
            const currRecord = { id: new Date().getTime(), ...this.form, topicType: 'Judgment' };
            // 插入题目
            if (this.insertNum > 0) {
              quesTableList.splice(this.insertNum - 1, 0, currRecord);
              localStorage.setItem('quesTableList', JSON.stringify(quesTableList));
            } else {
              // 新增题目
              localStorage.setItem('quesTableList', JSON.stringify([...quesTableList, currRecord]));
            }
          }
          this.quesTableList = JSON.parse(localStorage.getItem('quesTableList')) || [];
          this.$emit('refreshData');
          // console.log('最新的列表信息：', this.quesTableList);
        }
      });
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
    },
  },
};
</script>
<style scoped lang="less">
.add-input {
  /deep/ .ant-form-item-children {
    display: flex;
    align-items: center;
    .ant-input {
      flex: 1;
    }
    .anticon-delete {
      width: 28px;
    }
  }
}
</style>
